/**
 * Created by JackCui on 2021/3/17
 */

/**
 * @param params {string, number}
 * @return {boolean}
 */
export const valueIsNull = (params) => {
  return !params && (typeof params) !== 'undefined' && params !== 0
}

// 数字类型等于
export const NUMBER_EQUAL = (a, b) => {
  return !valueIsNull(a) && !valueIsNull(b) && Number(a) === Number(b)
}
// 数字类型大于
export const NUMBER_MORE_THAN = (a, b) => {
  return !valueIsNull(a) && !valueIsNull(b) && Number(a) > Number(b)
}
// 数字类型大于等于
export const NUMBER_NO_LESS_THAN = (a, b) => {
  return !valueIsNull(a) && !valueIsNull(b) && Number(a) >= Number(b)
}
// 数字类型小于
export const NUMBER_LESS_THAN = (a, b) => {
  return !valueIsNull(a) && !valueIsNull(b) && Number(a) < Number(b)
}
// 数字类型小于等于
export const NUMBER_NO_MORE_THAN = (a, b) => {
  return !valueIsNull(a) && !valueIsNull(b) && Number(a) <= Number(b)
}
// 数字类型介于
export const NUMBER_BETWEEN = (a, b) => {
  if (valueIsNull(a) || valueIsNull(b)) {
    return false
  }
  const numA = Number(a)
  return numA > Number(b[0]) && numA < Number(b[1])
}
// 数字类型介于等于
export const NUMBER_BETWEEN_EQUAL = (a, b) => {
  if (valueIsNull(a) || valueIsNull(b)) {
    return false
  }
  const numA = Number(a)
  return numA >= Number(b[0]) && numA <= Number(b[1])
}
